import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// Register base components for global use
import 'vue-material-design-icons/styles.css'

import BaseIcon from 'base/components/BaseIcon.vue'
Vue.component('BaseIcon', BaseIcon)

import BasePopupMenu from 'base/components/BasePopupMenu.vue'
Vue.component('BasePopupMenu', BasePopupMenu)

import { router } from 'base/router'
import { store } from 'base/store'

import App from './App.vue'

Vue.config.productionTip = false
Vue.config.devtools = true

// tslint:disable-next-line: no-unused-expression
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App />'
})
